var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.334 6.66732C13.334 8.50898 11.8423 10.0007 10.0007 10.0007C8.15898 10.0007 6.66732 8.50898 6.66732 6.66732C6.66732 4.82565 8.15898 3.33398 10.0007 3.33398C11.8423 3.33398 13.334 4.82565 13.334 6.66732ZM3.33398 15.0006C3.33398 12.784 7.77565 11.6673 10.0007 11.6673C12.2256 11.6673 16.6673 12.784 16.6673 15.0006V16.6673H3.33398V15.0006Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.b4fbf5dac5b6be30ee062b441a518460.svg";
export { ForwardRef as ReactComponent };